import { TypographyType } from '@/common/components/base/typography/Typography.type.ts';
import Typography from '@/common/components/base/typography/Typography.tsx';
import { Box, Center } from 'styled-system/jsx';
import { css, cx } from 'styled-system/css';

const BulletTypography = ({
  backgroundColor = 'purple-primary',
  children,
  className,
  ...props
}: TypographyType) => {
  return (
    <Center>
      <Box
        flexShrink={0}
        backgroundColor={backgroundColor}
        className={cx(
          css({
            width: '5px',
            height: '5px',
            borderRadius: '50%',
            marginLeft: '10px',
            backgroundColor: backgroundColor,
          }),
          className,
        )}
      />
      <Typography {...props}>{children}</Typography>
    </Center>
  );
};
export default BulletTypography;
